import { BlastEvent, SimulationConfig } from '@/types';
import { getRadiusAtAngle } from '@/logic/break/BreakUtils';
import { registerBlastAnimation } from './BlastAnimationRegistry';

export const FireSpiralAnimation = (
  ctx: CanvasRenderingContext2D,
  e: BlastEvent,
  config: SimulationConfig,
  progress: number
) => {
  const useRGB = config.rgbLighting && config.useFXRGB && !config.blastMatchRingColor;
  if (useRGB) ctx.strokeStyle = `hsl(${(progress*150 + 20)%60}, 100%, 50%)`;
  ctx.beginPath();
  for(let a=0; a<Math.PI*6; a+=0.1){
    const rBase = e.maxRadius + progress * 200 * (a / (Math.PI*6));
    const ang = a + progress*15;
    const r = getRadiusAtAngle(ang, e, rBase);
    ctx.lineTo(e.pos.x + Math.cos(ang)*r, e.pos.y + Math.sin(ang)*r);
  }
  ctx.stroke();
};

registerBlastAnimation('FIRE_SPIRAL', FireSpiralAnimation);
